var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 91,
    viewBox: "0 0 106 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 53H92.6667C86.4074 53 81.3333 58.0741 81.3333 64.3333V75.6667C81.3333 81.9259 86.4074 87 92.6667 87C98.9259 87 104 81.9259 104 75.6667V53ZM104 53C104 24.8335 81.1665 2 53 2C24.8335 2 2 24.8335 2 53M2 53V75.6667C2 81.9259 7.07411 87 13.3333 87C19.5926 87 24.6667 81.9259 24.6667 75.6667V64.3333C24.6667 58.0741 19.5926 53 13.3333 53H2Z",
    stroke: "#B5B5B5",
    strokeWidth: 2.66667,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104 49.4062V72.0729C104 83.4063 100.222 89.0729 92.6668 89.0729C85.1113 89.0729 75.6668 89.0729 64.3335 89.0729",
    stroke: "#B5B5B5",
    strokeWidth: 2.66667,
    strokeLinecap: "square"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.3beb1c122578a74388c2d11f3aa56466.svg";
export { ForwardRef as ReactComponent };